<template>
  <div
    id="map-controls"
    :class="{'weather-menu': showWeatherMenu || showContour}"
  >
    <vx-tooltip text="地図の種類" position="left">
      <button class="map-control-button cursor-pointer" @click="SET_ACTIVE_LAYERS_SIDEBAR">
        <img :src="layersIcon">
      </button>
    </vx-tooltip>
    <vx-tooltip text="検索" position="left" class="relative" >
      <button class="map-control-button cursor-pointer" @click="SET_ACTIVE_SEARCH_SIDEBAR">
        <img :src="searchIcon">
      </button>
      <img v-if="isFreeAccount" :src="lockedForFreeAccountIcon" class="locked-for-free-account-icon" />
    </vx-tooltip>
    <vx-tooltip text="自社船" position="left" class="relative" >
      <button class="map-control-button cursor-pointer" @click="SET_ACTIVE_OWN_VESSEL_SIDEBAR">
        <img :src="ownVesselIcon">
      </button>
      <img v-if="isFreeAccount" :src="lockedForFreeAccountIcon" class="locked-for-free-account-icon" />
    </vx-tooltip>
    <vx-tooltip text="選択船" position="left" class="relative" >
      <button class="map-control-button cursor-pointer" @click="SET_ACTIVE_SELECT_VESSEL_SIDEBAR">
        <img :src="selectVesselIcon">
      </button>
      <img v-if="isFreeAccount" :src="lockedForFreeAccountIcon" class="locked-for-free-account-icon" />
    </vx-tooltip>
    <vx-tooltip text="車両" position="left" class="relative" >
      <button class="map-control-button cursor-pointer" @click="SET_ACTIVE_VEHICLE_SIDEBAR">
        <img :src="vehicleIcon">
      </button>
      <img v-if="isFreeAccount" :src="lockedForFreeAccountIcon" class="locked-for-free-account-icon" />
    </vx-tooltip>
    <vx-tooltip v-if="hasFloatingUnitPermission" text="海上設置物" position="left" class="relative" >
      <button class="map-control-button cursor-pointer" @click="SET_ACTIVE_FLOATING_UNIT">
        <img :src="floatingUnitIcon">
      </button>
    </vx-tooltip>
    <vx-tooltip text="表示フィルター" position="left">
      <button class="map-control-button cursor-pointer" @click="SET_ACTIVE_FILTER_SIDEBAR">
        <img :src="filterIcon">
      </button>
    </vx-tooltip>
    <vx-tooltip text="プロット" position="left" class="relative" >
      <button class="map-control-button cursor-pointer" @click="SET_ACTIVE_PLOT_SIDEBAR">
        <img :src="plotIcon">
      </button>
      <img v-if="isFreeAccount" :src="lockedForFreeAccountIcon" class="locked-for-free-account-icon" />
    </vx-tooltip>
    <vx-tooltip text="気象海象" position="left" class="relative" >
      <button class="map-control-button cursor-pointer" @click="onclickWeather">
        <img :src="weatherIcon ">
      </button>
      <img v-if="isFreeAccount" :src="lockedForFreeAccountIcon" class="locked-for-free-account-icon" />
    </vx-tooltip>
    <vx-tooltip text="設定" position="left" class="relative" >
      <button class="map-control-button cursor-pointer" @click="SET_ACTIVE_SETTINGS_SIDEBAR">
        <img :src="settingIcon">
      </button>
      <img v-if="isFreeAccount" :src="lockedForFreeAccountIcon" class="locked-for-free-account-icon" />
    </vx-tooltip>
  </div>
</template>

<script>
import AuthService from "@/services/authService";
import {createNamespacedHelpers, mapState} from "vuex";

// Store
const {
  mapMutations: mapMutationsOfLiveMap,
} = createNamespacedHelpers("liveMap");

export default {
  props: {
    map: Object,
    showWeatherMenu: Boolean,
    showContour: Boolean,
  },
  data() {
    return {
      menuBtnStyle: {},
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
      hasWeatherPermission: false,
      lockedForFreeAccountIcon: require("@/assets/images/icons/sideber-menu/locked.svg"),
      hasFloatingUnitPermission: false,
    };
  },
  watch: {
    layoutType(val) {
      if (val === "horizontal") {
        this.themeMode === "semi-dark" ? (this.themeMode = "light") : null;
        this.navbarType === "hidden"
          ? (this.navbarTypeLocal = "floating")
          : null;
        this.$emit("updateNavbarColor", "#fff");
      }
    },
    addons: {
      immediate: true,
      handler(newAddons) {
        this.hasFloatingUnitPermission = newAddons.some(addon => addon.id === AuthService.ADDON_IDS.FLOATING_UNIT);
      }
    }
  },
  computed: {
    ...mapState({
      addons: state => state.addons || []
    }),
    layersIcon() {
      return require("@/assets/images/icons/sideber-menu/layers.svg");
    },
    searchIcon() {
      return require("@/assets/images/icons/sideber-menu/search.svg");
    },
    ownVesselIcon() {
      return require("@/assets/images/icons/sideber-menu/vessel_own.svg");
    },
    selectVesselIcon() {
      return require("@/assets/images/icons/sideber-menu/vessel_select.svg");
    },
    vehicleIcon() {
      return require("@/assets/images/icons/sideber-menu/vehicle.svg");
    },
    filterIcon() {
      return require("@/assets/images/icons/sideber-menu/filter.svg");
    },
    floatingUnitIcon() {
      return require("@/assets/images/icons/sideber-menu/floating_unit.svg");
    },
    plotIcon() {
      return require("@/assets/images/icons/sideber-menu/plot.svg");
    },
    weatherIcon() {
      return (this.hasWeatherPermission || this.isFreeAccount ) ? require("@/assets/images/icons/sideber-menu/weather.svg") : require("@/assets/images/icons/sideber-menu/weather_locked.svg")
    },
    settingIcon() {
      return require("@/assets/images/icons/sideber-menu/setteing.svg");
    },
    imageSatellite() {
      return require("@/assets/images/pages/map/sattellite.png");
    },
    isFreeAccount() {
      return this.$store.state.isFree === true;
    },
  },
  methods: {
    ...mapMutationsOfLiveMap([
      "SET_ACTIVE_LAYERS_SIDEBAR",
      "SET_ACTIVE_SEARCH_SIDEBAR",
      "SET_ACTIVE_OWN_VESSEL_SIDEBAR",
      "SET_ACTIVE_SELECT_VESSEL_SIDEBAR",
      "SET_ACTIVE_FILTER_SIDEBAR",
      "SET_ACTIVE_PLOT_SIDEBAR",
      "SET_ACTIVE_WEATHER_SIDEBAR",
      "SET_ACTIVE_VEHICLE_SIDEBAR",
      "SET_ACTIVE_FLOATING_UNIT",
      "SET_ACTIVE_SETTINGS_SIDEBAR"
    ]),
    onclickWeather(){
      if(!this.hasWeatherPermission) return
      this.SET_ACTIVE_WEATHER_SIDEBAR(true)
    },
  },
  async created() {
    // メニュー表示制御を実行
    this.hasWeatherPermission = await AuthService.hasAddon(AuthService.ADDON_IDS.POLARIS)

    if (this.addons) {
      this.hasFloatingUnitPermission = this.addons.some(addon => addon.id === AuthService.ADDON_IDS.FLOATING_UNIT);
    }
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";

#map-controls {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;

  @media screen and (max-height: $min-width-iphone-8) and (max-width: $max-width-iphone-11-pro) {
    max-height: 240px;
  }

  .map-control-button {
    margin: 3px;
    width: 50px;
    height: 50px;
    font-size: 20px;
    text-decoration: none;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #2D9CDB;
    border-radius: 5px;
    border: none;
    outline: none;
  }

  .map-style-changer-button {
    img {
      width: 50px;
      height: 50px;
      border-radius: 5px;
    }
  }

  &.weather-menu {
    @media screen and (max-height: $max-width-iphone-11-pro) and (max-width: $min-width-iphone-11-pro) {
      max-height: 240px;
    }
  }

  .locked-for-free-account-icon {
    position: absolute;
    top:     3px;
    left:    3px;
    width:  50px;
    height: 50px;
    z-index:   9;
    border-radius: 5px;
    background-color: rgba($aisea-slightly-gray, 0.4);
  }
}


</style>
